var capitalize = function capitalize(string) {
  return string.split('_').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};
export default capitalize;